










import { defineComponent, PropType } from "@vue/composition-api";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "ProfileTagsView",
  components: { BaseButton },
  props: {
    userTags: { type: Array as PropType<TagInfo[]>, required: true },
  },
});
